<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './sass/base.sass'
import './sass/app.sass'

export default {
  name: 'ad_app',
  data () {
    return {}
  },
  beforeCreate () {
    // 友盟
    var _czc = _czc || [];
    _czc.push(["_setAccount", 1276885859]);
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://s5.cnzz.com/z_stat.php?id=1276885859&web_id=1276885859";
    script.id = 'Site_Count'
    if (document.getElementById('Site_Count')) document.getElementById('Site_Count').remove()
    document.body.appendChild(script);
  }
}
</script>

<style lang="sass">
.left-close-userImg
  width: 30px
  height: 30px
  margin-top: 70px

.user-ctn
  padding: 15px 20px
  position: relative

#app
  height: 100%
</style>

